$(document).ready(function() {
    if(!document.querySelector('.GPC0031')) return false;
    $(".GPC0031").find('picture source').remove();
    $(".GPC0031").find('.inside-component .component-wrap').wrap('<div class="inside-inner"></div>');
    $('.GPC0031').each(function(){
        var $iconblock = $(this).find('.GPC0088');
        if ($iconblock.length) {
            var componentCarouselSimple = {
                $el : null,
                init : function() {
                    this.$el = $iconblock;
                    this.$el.find('.spec-list').not('.none-slide').not('.slick-initialized').each(function(){
                        if($(this).find('.item').length>1) {
                            componentCarouselSimple.runSlick($(this));
                            $(this).parents('.GPC0088').addClass('bindSlick');
                        }
                    });
                    this.$el.find('.spec-list.none-slide').each(function(){
                        if($(this).find('.item').length>2) {
                            $(this).removeClass('none-slide');
                            componentCarouselSimple.runSlick($(this));
                            $(this).parents('.GPC0088').addClass('bindSlick');
                        } else{
                            $(this).addClass('none-slide');
                        }
                    });
                },
                runSlick: function($obj) {
                    $obj.slick({
						appendDots:$obj.siblings('.slick-indicator').find('.slick-dot-wrap'),
						responsive: [
							{
								breakpoint: 9999,
								settings: 'unslick'
							},
							{
								breakpoint: 767,
								settings: {
									infinite: false,
									slidesToShow: 1,
									slidesToScroll: 1,
									arrows : false,
									dots: true,
								}
							}
						]
					});
                    $obj.on('afterChange', function(event, slick, currentSlide){
                        //console.log('..');
                    });
                    $obj.on('breakpoint', function(event, slick, breakpoint) {
                        // console.log('breakpoint ' +  breakpoint);
                        if( breakpoint === 767 ) {
                            eventStopOn();
                        }
                        if ( breakpoint === 9999 ) {
                            $obj.off('mousedown.stop touchstart.stop');
                        }
                    });
                    $(window).on('resize',function(){
                        $obj.slick('resize');
                        if( ! mql.maxSm.matches) {
                            $obj.find('.item').removeAttr('role id tabindex aria-describedby aria-hidden');
                        }
                    }).resize();
                    function eventStopOn() {
                        $obj.on('mousedown.stop touchstart.stop', function (e) {
                            e.stopPropagation();
                        });
                    }
                    if( mql.maxSm.matches) {
                        eventStopOn();
                    }
                }
            };
            componentCarouselSimple.init();
        }
        // LGEKZ-70 Date shows in wrong format, CNXSUPPORT-1761 START
        var $obj = $(this),
            countryCode = $("html").attr("data-countrycode").toLowerCase(),
            $mdyFormat = $obj.find('[data-dateFormat="mm-dd-yyyy"]'), // defaultFormat
            $dmyForamt = $obj.find('[data-dateFormat="dd-mm-yyyy"]'),
            $ymdZeroForamt = $obj.find('[data-dateFormat="yyyy-mm-dd"]'),
            $formatBlock,
            dmDateCountry = 'kz',
            zeroDateCountry = 'hu|hr|bg|rs';

        if (dmDateCountry.indexOf(countryCode) != -1) {
            $formatBlock = $dmyForamt;
        } else if(zeroDateCountry.indexOf(countryCode) != -1) {
            $formatBlock = $ymdZeroForamt;
        } else {
            $formatBlock = $mdyFormat;
        }
        $formatBlock.show();
        $obj.find('.date').not($formatBlock).remove();
        // LGEKZ-70 Date shows in wrong format, CNXSUPPORT-1761 END
    });
});